<template>
  <div class="chat-content" style="left: 320px;">
    <div ref="mailContentHeader" class="chat-content-header">
      <div class="d-flex">
        <nav id="channelNav"></nav>
      </div>
    </div>

    <div
      class="ps chat-content-body pd-t-20"
      :style="`height:calc(100vh - 170px)`"
    >
      <vuescroll ref="mainScrll" :ops="scrollOps" @handle-scroll="handleScroll">
        <div class="chat-group">
          <template v-for="(c, i) in comments">
            <div
              :key="i + 'g'"
              class="chat-group-divider"
              v-show="isDrawGroupDateRange(i)"
            >
              <label class="box-list-divider mg-l-0 m-0 tx-color-02">{{
                c.groupDate
              }}</label>
            </div>
            <div class="media mg-x-10 mg-y-10" :key="i">
              <div class="media-body mg-l-10">
                <h6>
                  <template v-if="c.rawUrl != '' && c.rawUrl != null">
                    <router-link :to="c.rawUrl">{{
                      c.customTitle
                    }}</router-link>
                  </template>
                  <small
                    >{{ c.date | moment("YYYY.MM.DD HH:mm") }},
                    {{ c.date | moment("dddd") }}</small
                  >
                </h6>
                <div class="d-flex align-items-center">
                  <div>
                    <p>
                      {{ c.execution }}
                      <a
                        role="button"
                        v-show="c.attachmentId != null"
                        @click="$emit('on-attach', c.attachmentId)"
                        ><feather
                          type="paperclip"
                          :stroke-width="1"
                          :size="12"
                          class="pd-r-5 pd-l-5"
                        ></feather
                        >хавсралт</a
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </vuescroll>
    </div>
    <media-finder
      v-if="mediaFinder.show"
      @on-attach="fileAttached"
      @on-task-close="mediaFinder.show = false"
    ></media-finder>
    <div v-if="composeObj.chooserShow" class="chat-content-footer-top wd-30p">
      <simple-uploader
        v-model="composeObj.attachId"
        :propBoxId="0"
        :propObjectId="'0'"
        :propObjectTypeId="6"
        @on-success="fileUploaded($event)"
      >
        <div slot="trigger">
          <div v-if="composeObj.attachId == null" class="btn-group wd-100p">
            <div class="btn btn-outline-success">
              <feather type="upload" class="mg-r-5"></feather>
              <span>Компьютероос файл хуулах</span>
            </div>
          </div>
          <div v-else class="btn-group wd-100p">
            <div
              class="btn btn-outline-success"
              @click.stop="$emit('on-attach', composeObj.attachId)"
            >
              <feather type="eye"></feather>Файл харах
            </div>
            <div
              class="btn btn-danger"
              @click.prevent.stop="composeObj.attachId = null"
            >
              <feather type="x"></feather> Салгах
            </div>
          </div>
        </div>
      </simple-uploader>
      <!-- <hr/>
      <a @click="composeObj.chooserShow=false" class="btn btn-xs btn-danger btn-uppercase d-flex" role="button">Хаах</a> -->
      <!-- <div @click="mediaFinder.show = 1">
        <a role="button" >
          <feather type="cloud"></feather> Миний файлуудаас сонгох
        </a>
      </div>-->
      <!-- <div class="bd-l m-l-xl p-l-xl">
        <span>
          <i class="ivu-icon ivu-icon-md-add"></i>Компьютеороос хуулах
        </span>
      </div>-->
    </div>
    <div
      ref="chatComposeArea"
      class="chat-content-footer d-flex justify-content-center align-items-center bd-t ht-55"
    >
      <nav class="wd-10p text-center">
        <a
          v-show="!composeObj.chooserShow"
          @click="composeObj.chooserShow = true"
        >
          <feather type="plus"></feather>
        </a>
        <a
          v-show="composeObj.chooserShow"
          @click="composeObj.chooserShow = false"
        >
          <feather type="x"></feather>
        </a>
      </nav>
      <a
        @click="filterByRawUrl()"
        class="chat-plus wd-10p text-center"
        role="button"
      >
        <feather v-if="!rawUrlFiltered" type="filter"></feather>
        <feather v-if="rawUrlFiltered" type="x"></feather>
      </a>
      <a @click="downloadComment()" class="wd-10p text-center" role="button">
        <feather type="download"></feather>
      </a>
      <form @submit.prevent="sendMessage()" class="wd-60p">
        <input
          v-model="composeObj.txt"
          type="text"
          class="el-input__inner mg-l-5"
          placeholder="Тэмдэглэл"
        />
      </form>
      <nav class="wd-10p text-center">
        <a @click="sendMessage()" role="button">
          <feather type="send"></feather>
        </a>
      </nav>
    </div>
  </div>
</template>

<script>
import { request } from "@/api/all";
var _ = require("lodash");
const moment = require("moment");
import vuescroll from "vuescroll";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
var JSZip = require("jszip");
var JSZipUtils = require("jszip-utils");
var Docxtemplater = require("docxtemplater");
import Axios from "axios";
import { getToken } from "@/libs/util";

export default {
  components: {
    vuescroll,
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    mediaFinder: () => ({
      component: import("@/components/modules/media/finder"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    taskId: {
      type: Number,
      default: () => null
    },
    obj: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      scrollOps: {
        vuescroll: {},
        scrollPanel: {},
        rail: {},
        bar: {}
      },
      skip: 0,
      comments: [],
      reportComments: [],
      allCount: 0,
      composeObj: {
        attachTitle: "",
        isDone: false,
        txt: "",
        type: 0,
        chooserShow: false,
        attachId: null,
        attachIds: [],
        attachList: []
      },
      isScrollHandled: false,
      chatAttachOption: {
        title: "",
        rawUrl: ""
      },
      fileUploaderVisible: false,
      mediaFinder: {
        show: false,
        obj: 0,
        key: 0
      },
      rawUrlFiltered: false,
      selfRpIn: 0,
      selectedFolderId: -999,
      publicPath: process.env.BASE_URL,
      baseURL: "https://mobcore.gosmart.mn/"
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.baseUrl != undefined &&
      this.$store.state.app.activeGroup.baseUrl != ""
    ) {
      this.baseURL = this.$store.state.app.activeGroup.baseUrl;
    }

    this.setChatAttachOption();
    this.load(false);
  },

  methods: {
    loadFile(url, callback) {
      JSZipUtils.getBinaryContent(url + "?r=" + Date(), callback);
    },
    doFile(data) {
      var self = this;
      self.selfRpIn = 1;
      self.loadFile(
        self.publicPath + "/assets/docx/notetemplate/note.docx",
        function(error, content) {
          if (error) {
            throw error;
          }
          var zip = new JSZip(content);
          var expressions = require("angular-expressions");
          expressions.filters.toadate = function(input) {
            if (!input) return "";
            if (input.split("T").length > 0) return input.split("T")[0];
          };
          expressions.filters.ind = function() {
            return self.selfRpIn++;
          };
          var angularParser = function(tag) {
            return {
              get:
                tag === "."
                  ? function(s) {
                      return s;
                    }
                  : function(s) {
                      return expressions.compile(tag.replace(/(’|“|”)/g, "'"))(
                        s
                      );
                    }
            };
          };
          var doc = new Docxtemplater();
          doc.loadZip(zip).setOptions({ parser: angularParser });
          self.renderReport(data, doc);
        }
      );
    },
    renderReport(data, doc) {
      let docData = { title: this.obj.name, lists: data };
      doc.setData(docData);
      try {
        doc.render();
      } catch (error) {
        //console.log(error);
        // var e = {
        //   message: error.message,
        //   name: error.name,
        //   stack: error.stack,
        //   properties: error.properties
        // };
        throw error;
      }
      var out = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      });
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + getToken()
        }
      };
      let fd = new FormData();
      let r = Math.random()
        .toString(36)
        .substring(7);
      fd.append("file", out, "Report" + r + ".docx");
      return Axios.post(
        this.baseURL +
          "core/uploader?folderId=" +
          this.selectedFolderId +
          "&boxId=0&objectTypeId=6&objectId=0&mode=0&isPublic=true&token=" +
          getToken(),
        fd,
        config
      ).then(res => {
        //console.log(res);
        this.$emit("on-attach", res.data.data.uploadedAttachmentId);
      });
    },
    downloadComment() {
      let self = this;
      self.reportComments = [];
      let urlFiltered = this.rawUrlFiltered == true ? this.$route.path : "";
      request({
        api: { method: "get", url: "TaskInUser/GetNoteExecutionSkipLog" },
        store: self.$store,
        params: {
          taskId: this.taskId,
          size: 10000,
          skip: 0,
          rawUrl: urlFiltered
        }
      }).then(res => {
        //self.allCount = res.data.allCount;
        _.orderBy(res.data.users, ["id"], ["desc"]).forEach(value => {
          Object.assign(value, {
            groupDate: self.getDateGroupName(value.date)
          });
          self.reportComments.unshift(value);
        });
        self.doFile(self.reportComments);
      });
    },
    filterByRawUrl() {
      this.rawUrlFiltered = !this.rawUrlFiltered;
      this.load(true);
    },
    fileUploaded(e) {
      //field.uv = false;
      // this.$data["taskModel"][field.key] = e.uploadedName;
      // this.$data["taskModel"][field.field] = e.uploadedAttachmentId;
      this.composeObj.attachTitle = e.uploadedName;
      this.composeObj.attachId = e.uploadedAttachmentId;
      //field.cstmFld1 = e.uploadedUrl;
    },
    fileAttached(e) {
      this.composeObj.attachTitle = e.t;
      this.composeObj.attachId = e.id;
      this.mediaFinder.show = false;
    },
    showFinder() {
      //this.mediaFinder.obj = e;
      this.mediaFinder.show = true;
    },
    setChatAttachOption() {
      if (this.obj != null) {
        this.chatAttachOption.title = this.obj.title;
        this.chatAttachOption.rawUrl = this.$route.path;
      }
    },
    isDrawGroupDateRange(i) {
      if (i == 0) {
        return true;
      } else if (
        this.comments[i]["groupDate"] != this.comments[i - 1]["groupDate"]
      ) {
        return true;
      } else {
        return false;
      }
    },
    getDateGroupName(d) {
      let rv = "";
      if (moment(d).isSame(new Date(), "day")) {
        rv = "Өнөөдөр";
      } else if (moment(d).isSame(moment().subtract(1, "day"), "day")) {
        rv = "Өчигдөр " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(moment().subtract(2, "day"), "day")) {
        rv = "Уржигдар " + moment(d).format("| dddd гараг - MMMM, DD");
      } else if (moment(d).isSame(new Date(), "week")) {
        rv = "Энэ долоо хоногт";
      } else if (moment(d).isSame(moment().subtract(1, "week"), "week")) {
        rv = "Өнгөрсөн долоо хоногт";
      } else if (moment(d).isSame(new Date(), "month")) {
        rv = "Энэ сард";
      } else if (moment(d).isSame(moment().subtract(1, "month"), "month")) {
        rv = "Өнгөрсөн сард";
      } else if (moment(d).isSame(new Date(), "year")) {
        rv = moment(d).format("MMMM") + "д";
        //rv= 'Энэ жилд';
      } else if (moment(d).isSame(moment().subtract(1, "year"), "year")) {
        rv = "Өнгөрсөн жилд";
      } else {
        rv = moment(d).format("YYYY") + " онд";
        //rv='Бусад';
      }
      return rv;
    },
    openCompose() {
      this.composeObj.chooserShow = !this.composeObj.chooserShow;
    },
    handleScroll(vertical) {
      if (vertical.scrollTop < 20 && !this.isScrollHandled) {
        //this.convCur.curPage = this.convCur.curPage + 1;
        if (this.comments.length < this.allCount && !this.isScrollHandled) {
          this.isScrollHandled = true;
          this.load(false);
        }
      }
    },
    sendMessage() {
      let self = this;
      request({
        api: { method: "post", url: "TaskInUser/PostNoteExecution" },
        store: self.$store,
        data: {
          taskId: this.taskId,
          isDone: this.composeObj.isDone,
          execution: this.composeObj.txt,
          perc: this.composeObj.perc,
          customTitle: this.chatAttachOption.title,
          rawUrl: this.chatAttachOption.rawUrl,
          attachmentId: this.composeObj.attachId
        }
      }).then(res => {
        if (res != false) {
          self.comments.push({
            id: res.data.id,
            execution: this.composeObj.txt,
            date: res.data.date,
            attachmentId: this.composeObj.attachId,
            isDeleted: false,
            rawUrl: this.chatAttachOption.rawUrl,
            customTitle: this.chatAttachOption.title,
            groupDate: self.getDateGroupName(res.data.date)
          });

          this.composeObj.chooserShow = false;
          this.composeObj.txt = "";
          this.composeObj.attachId = null;
          //push
        }
      });
    },
    load(force) {
      let self = this;
      if (force) self.comments = [];
      let urlFiltered = this.rawUrlFiltered == true ? this.$route.path : "";
      request({
        api: { method: "get", url: "TaskInUser/GetNoteExecutionSkipLog" },
        store: self.$store,
        params: {
          taskId: this.taskId,
          size: this.size,
          skip: this.comments.length,
          rawUrl: urlFiltered
        }
      }).then(res => {
        self.allCount = res.data.allCount;
        _.orderBy(res.data.users, ["id"], ["desc"]).forEach(value => {
          Object.assign(value, {
            groupDate: self.getDateGroupName(value.date)
          });
          self.comments.unshift(value);
        });
      });
    }
  }
};
</script>

<style>
.chat-content-footer-top {
  background-color: #fff;
  position: absolute;
  bottom: 51px;

  right: -1;
  border-top: 1px solid rgba(72, 94, 144, 0.16);
  height: 100px;
  display: flex;

  align-items: center;
  justify-content: center;
}
</style>
